import StreamLineIconsComponent from './StreamLineIconsComponent.vue'

//- The icons (vue-svg-loader will load any .svg as a component)

import slAthleticsTeamRunning from './Streamline/status/athletics-team-running.svg'
import slSmileySleepy from './Streamline/status/smiley-sleepy.svg'
import slMessage from './Streamline/status/messages-bubble-square-text.svg'
import slPlay from './Streamline/status/arrow_back_2.svg'
import slPause from './Streamline/status/pause.svg'
import slAbort from './Streamline/status/close.svg'

//- App
import slAlarm from './Streamline/app/alarm-bell.svg'
import slBankID from './Streamline/app/jp-bankid_monochr.svg'
import slMenu from './Streamline/app/navigation-menu-vertical.svg'
import slEbook from './Streamline/app/calendar-check-1.svg'
import slFile from './Streamline/app/common-file-text.svg'
import slNotes from './Streamline/app/notes-paper-text.svg'
import slExcel from './Streamline/app/office-file-sheet.svg'
import slEbookAdd from './Streamline/app/notes-add.svg'
import slViewOn from './Streamline/app/view-1.svg'
import slViewOff from './Streamline/app/view-off.svg'
import slEbookCompleted from './Streamline/app/jp-e-book-completed.svg'
import slIkonBuilding from './Streamline/app/ikon-building-daylight.svg'
import slStairsAscend from './Streamline/app/stairs-ascend.svg'
import slElements from './Streamline/app/module-three-1.svg'
import slInvitation from './Streamline/app/invitation.svg'
import slManual from './Streamline/app/book-play.svg'
import slTaskListApprove from './Streamline/app/task-list-approve.svg'

//-Persons
import slUser from './Streamline/person/single-neutral-circle.svg'
import slUser2 from './Streamline/person/single-neutral.svg'
import slStaff from './Streamline/person/multiple-users-1.svg'
import slDistanceAdmin from './Streamline/person/single-woman-actions-money.svg'
import slUserBlock from './Streamline/person/single-neutral-actions-block.svg'
import slInstructor from './Streamline/person/professions-man-construction-1.svg'
import slYUA from './Streamline/person/school-teacher-a.svg'
import slApprentice from './Streamline/person/read-human.svg'
import slAdmin from './Streamline/person/history-man-king.svg'
import slUserProtect from './Streamline/person/single-neutral-actions-remove.svg'

//-Actions
import slLink from './Streamline/action/hyperlink-3.svg'
import slUnLink from './Streamline/action/link-broken.svg'
import slPauseQtime from './Streamline/action/link-broken-1.svg'
import slStop from './Streamline/action/stop-sign.svg'
import slRefresh from './Streamline/action/button-refresh-arrows.svg'
import slBynlogo from './Streamline/action/BYN_Logo.svg'
import slspinner from './Streamline/action/spinner.svg'
import slDelete from './Streamline/action/bin-paper-1.svg'
import slLike from './Streamline/action/like-2.svg'
import slDislike from './Streamline/action/dislike-2.svg'
import slEdit from './Streamline/action/pencil-2.svg'
import slJpChecked from './Streamline/action/check-circle-1.svg'
import slSave from './Streamline/action/check-1.svg'
import slSingleNeutralActionsCheck from './Streamline/person/single-neutral-actions-check-1.svg'
import slTradecertificate from './Streamline/person/certified-diploma-1.svg'
import slHumanResourcesHierarchy from './Streamline/action/human-resources-hierarchy.svg'
import slSwitchAccount from './Streamline/action/switch-account.svg'

import slSaveFilled from './Streamline/action/check-circle-1-filled.svg'
import slCancel from './Streamline/action/delete-1.svg'
import slDeny from './Streamline/action/delete.svg'
import slAdd from './Streamline/action/add.svg'
import slCalendar from './Streamline/action/calendar.svg'
import slCalendarDate from './Streamline/action/calendar-date.svg'
import slSearch from './Streamline/action/search.svg'
import slSearchSettings from './Streamline/action/cog-search-1.svg'
import slClose from './Streamline/action/close.svg'
import slMobile from './Streamline/devices/mobile-phone.svg'
import slEmail from './Streamline/devices/email-action-unread.svg'
import slLockPassword from './Streamline/action/lock-password.svg'
import slLocked from './Streamline/action/lock-1.svg'
import slUnLocked from './Streamline/action/lock-unlock.svg'
import slJpCheckedSquare from './Streamline/action/jp-check-square-bold-locked.svg'
import slJpUnCheckedSquare from './Streamline/action/keyboard-button.svg'
import slUndo from './Streamline/action/undo.svg'
import slRedo from './Streamline/action/redo.svg'
import slDownload from './Streamline/action/download-circle.svg'
import slUpload from './Streamline/action/upload-circle.svg'
import slPrinter from './Streamline/action/printer.svg'
import slSend from './Streamline/action/send-email.svg'
import slUploadButton from './Streamline/action/upload-button.svg'
import slPasswordApproved from './Streamline/action/password-approved.svg'
import slPasswordDenied from './Streamline/action/password-denied.svg'
import slPasswordType from './Streamline/action/password-type.svg'
import slPasswordLock1 from './Streamline/action/password-lock-1.svg'
import slContentPaperEdit from './Streamline/action/content-paper-edit.svg'
import slShipmentBox from './Streamline/action/shipment-box.svg'
import slAccountingInvoice from './Streamline/action/accounting-invoice.svg'
import slDeliveryTruckBolt from './Streamline/action/delivery_truck_bolt.svg'
import slHistoryEducation from './Streamline/action/history_edu.svg'

//-Menu
import slMonitorChart from './Streamline/menu/monitor-chart.svg'
import slMultipleNeutral from './Streamline/menu/multiple-neutral-2.svg'
import slBuldingDayLight from './Streamline/menu/building-daylight.svg'
import slBusinessContractApprove from './Streamline/menu/business-contract-approve.svg'
import slNotesPaperApprove from './Streamline/menu/notes-paper-approve.svg'
import slShieldSettings from './Streamline/menu/shield-settings.svg'
import slMultipleActionsText from './Streamline/menu/multiple-actions-text.svg'
import slBusinessContractGive from './Streamline/menu/business-contract-give.svg'
import slProfessionsManConstruction from './Streamline/menu/professions-man-construction-1.svg'
import slSchoolTeacherCorrect from './Streamline/menu/school-teacher-correct.svg'
import slElearningBookSmartphone from './Streamline/menu/e-learning-book-smartphone.svg'
import slToysLego from './Streamline/menu/toys-lego.svg'
import slCogSquare from './Streamline/menu/cog-square.svg'
import slQuestionCircle from './Streamline/menu/question-circle.svg'
import slOutdoorsLandscape from './Streamline/menu/outdoors-landscape.svg'
import slLogout from './Streamline/menu/logout-2.svg'
import slLogin from './Streamline/menu/login-3.svg'
import slInformationCircle from './Streamline/menu/information-circle.svg'
import slBookFlipPage from './Streamline/menu/book-flip-page.svg'
import slWidening from './Streamline/menu/human-resources-employee-previous.svg'
import slStatistics from './Streamline/menu/statistics-daytum.svg'

//-Directions
import slArrowDown from './Streamline/directions/arrow-down-1.svg'
import slArrowLeft from './Streamline/directions/arrow-left-1.svg'
import slArrowRight from './Streamline/directions/arrow-right-1.svg'
import slArrowUp from './Streamline/directions/arrow-up-1.svg'
import slNavLeft from './Streamline/directions/navigation-left.svg'
import slGoRight from './Streamline/directions/navigation-right-circle.svg'
import slMoveShrinkVertical from './Streamline/directions/move-shrink-vertical.svg'
import slMoveExpandVertical from './Streamline/directions/move-expand-vertical.svg'
import slDoubleArrowRight from './Streamline/directions/arrow-double-right.svg'

//- Alerts
import slInfo from './Streamline/alerts/information-circle.svg'
import slInfoSmallFilled from './Streamline/alerts/information-circle-small-filled.svg'
import slAlert from './Streamline/alerts/alert-circle.svg'
import slWarning from './Streamline/alerts/road-sign-warning.svg'
import slCheckCircle from './Streamline/alerts/check-circle-1.svg'
import slTrafficLights from './Streamline/alerts/road-traffic-lights.svg'

const SLIcons = {
  //- App
  'sl-alarm': { component: StreamLineIconsComponent, props: { cmp: slAlarm } },
  'sl-bankid': { component: StreamLineIconsComponent, props: { cmp: slBankID } },
  'sl-menu': { component: StreamLineIconsComponent, props: { cmp: slMenu } },
  'sl-ebook': { component: StreamLineIconsComponent, props: { cmp: slEbook } },
  'sl-notes': { component: StreamLineIconsComponent, props: { cmp: slNotes } },
  'sl-excel': { component: StreamLineIconsComponent, props: { cmp: slExcel } },
  'sl-file': { component: StreamLineIconsComponent, props: { cmp: slFile } },
  'sl-ebook-add': { component: StreamLineIconsComponent, props: { cmp: slEbookAdd } },
  'sl-view-on': { component: StreamLineIconsComponent, props: { cmp: slViewOn } },
  'sl-view-off': { component: StreamLineIconsComponent, props: { cmp: slViewOff } },
  'sl-ebook-completed': { component: StreamLineIconsComponent, props: { cmp: slEbookCompleted } },
  'sl-ikon-building': { component: StreamLineIconsComponent, props: { cmp: slIkonBuilding } },
  'sl-stairs-ascend': { component: StreamLineIconsComponent, props: { cmp: slStairsAscend } },
  'sl-elements': { component: StreamLineIconsComponent, props: { cmp: slElements } },
  'sl-invitation': { component: StreamLineIconsComponent, props: { cmp: slInvitation } },
  'sl-manual': { component: StreamLineIconsComponent, props: { cmp: slManual } },
  'sl-task-list-approve': { component: StreamLineIconsComponent, props: { cmp: slTaskListApprove } },

  //-Persons
  'sl-user': { component: StreamLineIconsComponent, props: { cmp: slUser } },
  'sl-user2': { component: StreamLineIconsComponent, props: { cmp: slUser2 } },
  'sl-staff': { component: StreamLineIconsComponent, props: { cmp: slStaff } },
  'sl-instructor': { component: StreamLineIconsComponent, props: { cmp: slInstructor } },
  'sl-apprentice': { component: StreamLineIconsComponent, props: { cmp: slApprentice } },
  'sl-yua': { component: StreamLineIconsComponent, props: { cmp: slYUA } },
  'sl-admin': { component: StreamLineIconsComponent, props: { cmp: slAdmin } },
  'sl-distance-admin': { component: StreamLineIconsComponent, props: { cmp: slDistanceAdmin } },
  'sl-user-block': { component: StreamLineIconsComponent, props: { cmp: slUserBlock } },
  'sl-user-protect': { component: StreamLineIconsComponent, props: { cmp: slUserProtect } },

  //  statuses
  'sl-athletics-team-running': { component: StreamLineIconsComponent, props: { cmp: slAthleticsTeamRunning } },
  'sl-smiley-sleepy': { component: StreamLineIconsComponent, props: { cmp: slSmileySleepy } },
  'sl-message': { component: StreamLineIconsComponent, props: { cmp: slMessage } },
  'sl-play': { component: StreamLineIconsComponent, props: { cmp: slPlay } },
  'sl-pause': { component: StreamLineIconsComponent, props: { cmp: slPause } },
  'sl-abort': { component: StreamLineIconsComponent, props: { cmp: slAbort } },

  //-actions
  'sl-link': { component: StreamLineIconsComponent, props: { cmp: slLink } },
  'sl-unlink': { component: StreamLineIconsComponent, props: { cmp: slUnLink } },
  'sl-pause-qtime': { component: StreamLineIconsComponent, props: { cmp: slPauseQtime } },
  'sl-stop': { component: StreamLineIconsComponent, props: { cmp: slStop } },
  'sl-refresh': { component: StreamLineIconsComponent, props: { cmp: slRefresh } },
  'sl-BYN_Logo': { component: StreamLineIconsComponent, props: { cmp: slBynlogo } },
  'sl-spinner': { component: StreamLineIconsComponent, props: { cmp: slspinner } },
  'sl-delete': { component: StreamLineIconsComponent, props: { cmp: slDelete } },
  'sl-like': { component: StreamLineIconsComponent, props: { cmp: slLike } },
  'sl-dislike': { component: StreamLineIconsComponent, props: { cmp: slDislike } },
  'sl-edit': { component: StreamLineIconsComponent, props: { cmp: slEdit } },
  'sl-check': { component: StreamLineIconsComponent, props: { cmp: slJpChecked } },
  'sl-save-filled': { component: StreamLineIconsComponent, props: { cmp: slSaveFilled } },
  'sl-save': { component: StreamLineIconsComponent, props: { cmp: slSave } },
  'sl-user-check': { component: StreamLineIconsComponent, props: { cmp: slSingleNeutralActionsCheck } },
  'sl-cert': { component: StreamLineIconsComponent, props: { cmp: slTradecertificate } },
  'sl-cancel': { component: StreamLineIconsComponent, props: { cmp: slCancel } },
  'sl-deny': { component: StreamLineIconsComponent, props: { cmp: slDeny } },
  'sl-add': { component: StreamLineIconsComponent, props: { cmp: slAdd } },
  'sl-calendar': { component: StreamLineIconsComponent, props: { cmp: slCalendar } },
  'sl-calendar-date': { component: StreamLineIconsComponent, props: { cmp: slCalendarDate } },
  'sl-search': { component: StreamLineIconsComponent, props: { cmp: slSearch } },
  'sl-search-settings': { component: StreamLineIconsComponent, props: { cmp: slSearchSettings } },
  'sl-close': { component: StreamLineIconsComponent, props: { cmp: slClose } },
  'sl-lock-password': { component: StreamLineIconsComponent, props: { cmp: slLockPassword } },
  'sl-locked': { component: StreamLineIconsComponent, props: { cmp: slLocked } },
  'sl-unlocked': { component: StreamLineIconsComponent, props: { cmp: slUnLocked } },
  'sl-check-square': { component: StreamLineIconsComponent, props: { cmp: slJpCheckedSquare } },
  'sl-uncheck-square': { component: StreamLineIconsComponent, props: { cmp: slJpUnCheckedSquare } },
  'sl-undo': { component: StreamLineIconsComponent, props: { cmp: slUndo } },
  'sl-redo': { component: StreamLineIconsComponent, props: { cmp: slRedo } },
  'sl-download': { component: StreamLineIconsComponent, props: { cmp: slDownload } },
  'sl-upload': { component: StreamLineIconsComponent, props: { cmp: slUpload } },
  'sl-printer': { component: StreamLineIconsComponent, props: { cmp: slPrinter } },
  'sl-send': { component: StreamLineIconsComponent, props: { cmp: slSend } },
  'sl-human-hierarchy': { component: StreamLineIconsComponent, props: { cmp: slHumanResourcesHierarchy } },
  'sl-upload-button': { component: StreamLineIconsComponent, props: { cmp: slUploadButton } },
  'sl-password-approved': { component: StreamLineIconsComponent, props: { cmp: slPasswordApproved } },
  'sl-password-denied': { component: StreamLineIconsComponent, props: { cmp: slPasswordDenied } },
  'sl-password-type': { component: StreamLineIconsComponent, props: { cmp: slPasswordType } },
  'sl-password-lock-1': { component: StreamLineIconsComponent, props: { cmp: slPasswordLock1 } },
  'sl-content-paper-edit': { component: StreamLineIconsComponent, props: { cmp: slContentPaperEdit } },
  'sl-shipment-box': { component: StreamLineIconsComponent, props: { cmp: slShipmentBox } },
  'sl-accounting-invoice': { component: StreamLineIconsComponent, props: { cmp: slAccountingInvoice } },
  'sl-switch-account': { component: StreamLineIconsComponent, props: { cmp: slSwitchAccount } },
  'sl-delivery-truck-bold': { component: StreamLineIconsComponent, props: { cmp: slDeliveryTruckBolt } },
  'sl-history-education': { component: StreamLineIconsComponent, props: { cmp: slHistoryEducation } },

  //-Directions
  'sl-arrow-down': { component: StreamLineIconsComponent, props: { cmp: slArrowDown } },
  'sl-arrow-left': { component: StreamLineIconsComponent, props: { cmp: slArrowLeft } },
  'sl-arrow-right': { component: StreamLineIconsComponent, props: { cmp: slArrowRight } },
  'sl-arrow-up': { component: StreamLineIconsComponent, props: { cmp: slArrowUp } },
  'sl-navigate-left': { component: StreamLineIconsComponent, props: { cmp: slNavLeft } },
  'sl-go-right': { component: StreamLineIconsComponent, props: { cmp: slGoRight } },
  'sl-move-shrink-vertical': { component: StreamLineIconsComponent, props: { cmp: slMoveShrinkVertical } },
  'sl-move-expand-vertical': { component: StreamLineIconsComponent, props: { cmp: slMoveExpandVertical } },
  'sl-double-arrow-right': { component: StreamLineIconsComponent, props: { cmp: slDoubleArrowRight } },

  //-Menu
  'sl-monitor-chart': { component: StreamLineIconsComponent, props: { cmp: slMonitorChart } },
  'sl-multiple-neutral': { component: StreamLineIconsComponent, props: { cmp: slMultipleNeutral } },
  'sl-bulding-day-light': { component: StreamLineIconsComponent, props: { cmp: slBuldingDayLight } },
  'sl-business-contract-approve': { component: StreamLineIconsComponent, props: { cmp: slBusinessContractApprove } },
  'sl-notes-paper-approve': { component: StreamLineIconsComponent, props: { cmp: slNotesPaperApprove } },
  'sl-shield-settings': { component: StreamLineIconsComponent, props: { cmp: slShieldSettings } },
  'sl-multiple-actions': { component: StreamLineIconsComponent, props: { cmp: slMultipleActionsText } },
  'sl-business-contract': { component: StreamLineIconsComponent, props: { cmp: slBusinessContractGive } },
  'sl-profession-man-construction': { component: StreamLineIconsComponent, props: { cmp: slProfessionsManConstruction } },
  'sl-school-teacher': { component: StreamLineIconsComponent, props: { cmp: slSchoolTeacherCorrect } },
  'sl-elearning-book-smartphone': { component: StreamLineIconsComponent, props: { cmp: slElearningBookSmartphone } },
  'sl-toys-lego': { component: StreamLineIconsComponent, props: { cmp: slToysLego } },
  'sl-cog-square': { component: StreamLineIconsComponent, props: { cmp: slCogSquare } },
  'sl-question-circle': { component: StreamLineIconsComponent, props: { cmp: slQuestionCircle } },
  'sl-outdoors-landscape': { component: StreamLineIconsComponent, props: { cmp: slOutdoorsLandscape } },
  'sl-logout': { component: StreamLineIconsComponent, props: { cmp: slLogout } },
  'sl-login': { component: StreamLineIconsComponent, props: { cmp: slLogin } },
  'sl-information-circle': { component: StreamLineIconsComponent, props: { cmp: slInformationCircle } },
  'sl-book-flip-page': { component: StreamLineIconsComponent, props: { cmp: slBookFlipPage } },
  'sl-widening': { component: StreamLineIconsComponent, props: { cmp: slWidening } },
  'sl-statistics': { component: StreamLineIconsComponent, props: { cmp: slStatistics } },

  //- Devives
  'sl-mobile': { component: StreamLineIconsComponent, props: { cmp: slMobile } },
  'sl-email': { component: StreamLineIconsComponent, props: { cmp: slEmail } },

  //- Alerts
  'sl-info': { component: StreamLineIconsComponent, props: { cmp: slInfo } },
  'sl-info-small-filled': { component: StreamLineIconsComponent, props: { cmp: slInfoSmallFilled } },
  'sl-alert': { component: StreamLineIconsComponent, props: { cmp: slAlert } },
  'sl-warning': { component: StreamLineIconsComponent, props: { cmp: slWarning } },
  'sl-check-circle': { component: StreamLineIconsComponent, props: { cmp: slCheckCircle } },
  'sl-trafficlights': { component: StreamLineIconsComponent, props: { cmp: slTrafficLights } },

}

export default SLIcons
